// SPEC-COLLECTION-OFFLINE-COMPLETE-01 (D-268b) SCOPE_ADD_1 / FIX_C11: app_state ストア。
//   認証キャッシュ等のアプリ状態を keyPath='key' の専用ストアに置く(store_meta に非店舗行を混ぜない)。
import { getDb, STORE_APP_STATE } from './db'
import { logger } from '../logger'

const LOG_ERR_WRITE = 'ERR-LF1-IDB-WRITE'
const LOG_ERR_READ  = 'ERR-LF1-IDB-READ'

export async function putAppState(key, value) {
  if (!key) return
  try {
    const db = await getDb()
    const tx = db.transaction(STORE_APP_STATE, 'readwrite')
    await tx.store.put({ key, value, updatedAt: new Date().toISOString() })
    await tx.done
  } catch (err) {
    logger.error?.(LOG_ERR_WRITE, { key, message: err?.message })
  }
}

export async function getAppState(key) {
  if (!key) return null
  try {
    const db = await getDb()
    const row = await db.get(STORE_APP_STATE, key)
    return row ? row.value : null
  } catch (err) {
    logger.error?.(LOG_ERR_READ, { key, message: err?.message })
    return null
  }
}

export async function deleteAppState(key) {
  if (!key) return
  try {
    const db = await getDb()
    const tx = db.transaction(STORE_APP_STATE, 'readwrite')
    await tx.store.delete(key)
    await tx.done
  } catch (err) {
    logger.error?.(LOG_ERR_WRITE, { key, message: err?.message })
  }
}

// PHASE_C 認証キャッシュ(FIX_C11 で store_meta から移設)。accessToken は保持しない(送信時に取り直す)。
const AUTH_STAFF_KEY = 'auth_staff'

export async function putCachedStaff(meta) {
  if (!meta?.staffId) return
  await putAppState(AUTH_STAFF_KEY, {
    staffId: meta.staffId,
    staffName: meta.staffName ?? '',
    staffRole: meta.staffRole ?? 'staff',
    staffStoreCode: meta.staffStoreCode ?? null,
    cachedAt: new Date().toISOString(),
  })
}

export async function getCachedStaff() {
  const v = await getAppState(AUTH_STAFF_KEY)
  if (!v?.staffId) return null
  return {
    staffId: v.staffId,
    staffName: v.staffName ?? '',
    staffRole: v.staffRole ?? 'staff',
    staffStoreCode: v.staffStoreCode ?? null,
    accessToken: null,
  }
}

// FIX_C9: 自発的ログアウト時に消す。以後 session=null + キャッシュ無し = ログアウト、+ キャッシュ有り = 不本意な失効。
export async function deleteCachedStaff() {
  await deleteAppState(AUTH_STAFF_KEY)
}
